import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import type { MapOptions } from 'leaflet'
// React: import type { FC, ReactNode } from 'react'
import type { ComponentChildren, FunctionalComponent } from 'preact'
import { MapContainer, TileLayer, useMap  } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
//import { Navigation } from 'feather-icons-react';
import { handleChangeDataModalAddAddress } from '../../../../redux/actions/partials/modals/modalAddAddress';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import IconCurrentLocation from '../../../../styles/images/svg/current-location.svg';


function MyComponent(props) {
    const dispatch = useDispatch();

    const { type } = props.data;

    const {currentLocGlng, currentLocGlat} = useSelector(state => state.modalAddAddress); 

    const handleCurrentLocation = () => {
        if(currentLocGlng !== null && currentLocGlat != null) 
        {
            if(type === 'ADD') {
                dispatch(handleChangeDataModalAddAddress('currentLocGlat', currentLocGlat));
                dispatch(handleChangeDataModalAddAddress('currentLocGlng', currentLocGlng));
                map.flyTo([currentLocGlat, currentLocGlng], map.getZoom());
            }
            // else if(type === 'EDIT')
            //     dispatch(actionChangeLocationModalEditAddress(currentLocGlng, currentLocGlat));
        }
        else {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در دریافت موقعیت مکانی شما', severity: 'error'}));  
        }
    }


    // const [position, setPosition] = useState(null);
    // const [setPosition] = useState(null);
    const map = useMap();

    useEffect(() => {
        map.locate().on("locationfound", function (e) {
            // setPosition(e.latlng);
            map.flyTo(e.latlng, map.getZoom());

            if(type === 'ADD') {
                dispatch(handleChangeDataModalAddAddress('currentLocGlat', e.latlng.lat));
                dispatch(handleChangeDataModalAddAddress('currentLocGlng', e.latlng.lng));
            }
            // else if(type === 'EDIT')
            //     dispatch(actionSetCurrentLocationModalEditAddress(e.latlng.lat, e.latlng.lng));
            // const radius = e.accuracy;
            // const circle = L.circle(e.latlng, radius);
            // circle.addTo(map);
            // setBbox(e.bounds.toBBoxString().split(","));
        });


        map.on('drag', function (e) {
            if(type === 'ADD') {
                dispatch(handleChangeDataModalAddAddress('glat', map.getCenter().lat));
                dispatch(handleChangeDataModalAddAddress('glng', map.getCenter().lng));
            }
            // else if(type === 'EDIT')
            //     dispatch(actionChangeLocationModalEditAddress(map.getCenter().lng, map.getCenter().lat));
        });
        map.on('zoom', function (e) {
            if(type === 'ADD') {
                dispatch(handleChangeDataModalAddAddress('glat', map.getCenter().lat));
                dispatch(handleChangeDataModalAddAddress('glng', map.getCenter().lng));
            }
            // else if(type === 'EDIT')
            //     dispatch(actionChangeLocationModalEditAddress(map.getCenter().lng, map.getCenter().lat));
        });

    }, [map]);

        

    return (
        <div className='leaflet-bottom leaflet-left' style={{zIndex: "99999"}}>
            <div className="leaflet-control leaflet-bar">
                <div className='btn-my-location' onClick={handleCurrentLocation} style={{height: "30px", width: "30px", cursor: "pointer"}}>
                    {/*<Navigation size={30} style={{background: "white", padding: "3px"}} role="button"/>*/}
                    <img src={IconCurrentLocation} width={30} height={30} style={{background: "white", padding: "3px"}} role="button" />
                </div>
            </div>
        </div>
    )

    
}




const LeafletMap: FunctionalComponent<
    {
        center: [number, number],
        children: ComponentChildren,
        zoom: number,
    } & MapOptions
> = ({ children, ...options }) => {
    return (
        <MapContainer
            className=""
            style={{height: "300px"}}
            maxZoom={18}
            {...options}
        >
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            />
            {children}

            <MyComponent data={{type: options.data.type}}/>

        </MapContainer>
    )
}

export default LeafletMap